import { apolloSpy } from '@shortlyster/analytics-kit';
import mutationMap from './mutations';

export const watcher = (event: apolloSpy.EventData): void => {
  const { type, name } = event;
  if (type === 'mutation') {
    mutationMap[name] && mutationMap[name](event);
  }
};
